<template>
  <span>
    <span :class="`shipping-list-item-status font-weight-bold rounded-lg ${statusColorVariant}`" v-b-tooltip.hover :title="statusStrings[shipping.status]">
      {{ shipping.status }}
    </span>
    <div v-if="withEta && (shipping.distance || shipping.duration)" class="mt-1">
      <!-- <div v-if="shipping.distance" class="d-flex">
        <strong> v-translate>Distance</strong>
        <span class="ml-1 text-nowrap">{{distance(shipping.distance)}}</span>
      </div> -->
      <div v-if="shipping.duration" class="d-flex">
        <strong v-translate :title="$gettext('Estimated Time of Completion')">E.T.C.</strong>
        <span class="ml-1 text-nowrap">{{moment.duration(shipping.duration, 'seconds').format('d [days] h [hrs] m [min]')}}</span>
      </div>
      <div v-if="shipping.distance && shipping.duration" class="d-flex">
        <strong v-translate :title="$gettext('Estimated Time of Arrival')">E.T.A.</strong>
        <span v-show="shipping.eta" class="ml-1 text-nowrap"><span :title="moment.utc().add(shipping.eta, 'seconds').tz($tz).format('L LT')" v-b-tooltip>{{moment.duration(shipping.eta, 'seconds').format('d [days] h [hrs] m [min]')}}</span><eta-source :shipping="shipping" /></span>
        <span v-show="!shipping.eta" class="ml-1 text-nowrap" v-translate>N/A</span>
      </div>
    </div>
  </span>
</template>

<script>
import constants from '@/common/constants'
import ShippingsMixin from '@/mixins/shippings.mixin'
import EtaSource from '@/components/Shippings/EtaSource'

export default {
  name: 'ShippingsListItemStatus',
  components: {
    EtaSource
  },
  props: {
    shipping: {
      type: Object,
      required: true
    },
    withEta: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusColorVariant() {
      let cssClass
      if (this.shipping.status === 'CANCELED') {
        cssClass = 'text-danger'
      } else if (this.shipping.status === 'INCIDENCE' || this.shipping.status === 'WAITINGCLIENT' || this.shipping.status === 'TOBERETURNED' || (this.shipping.status === 'DRAFT' && this.shipping.fields_revision)) {
        cssClass = 'bg-warning'
      } else if (this.shipping.status === 'BLOCKED' || (this.shipping.status === 'DRAFT' && !this.shipping.fields_revision)) {
        cssClass = 'bg-dark text-white'
      } else if (this.shipping.status === 'DELIVERED' || this.shipping.status === 'RETURNED') {
        cssClass = 'text-success'
      } else {
        cssClass = 'bg-success text-white'
      }
      return cssClass
    }
  },
  mixins: [constants, ShippingsMixin],
  mounted() {
    // The shipping comes in as a prop already observed by ApiList, and none of these
    // keys exist on the API payload, so they need $set to be reactive.
    const { eta, etaType, etaUpdateDate } = this.getShippingEta(this.shipping)
    this.$set(this.shipping, 'eta', eta)
    this.$set(this.shipping, 'etaType', etaType)
    this.$set(this.shipping, 'etaUpdateDate', etaUpdateDate)
  }
}
</script>

<style lang="scss">
.shipping-list-item-status {
  display: inline-block;
  padding: 0 5px;
}
</style>
